import { useState } from "react";
import { BookOpen, ChevronDown, ChevronUp, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ProtocolReferences({ references }) {
  const [expanded, setExpanded] = useState(false);

  if (!references || references.length === 0) return null;

  return (
    <div className="border rounded-lg bg-card no-print" data-testid="protocol-references">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between px-4 py-3 hover:bg-muted/30 transition-colors"
        data-testid="references-toggle"
      >
        <span className="flex items-center gap-2 text-sm font-medium">
          <BookOpen className="w-4 h-4 text-primary" />
          References
          <span className="text-muted-foreground font-normal">({references.length})</span>
        </span>
        {expanded ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
      </button>

      {expanded && (
        <div className="px-4 pb-4 border-t">
          <ol className="space-y-3 mt-3 list-decimal list-inside">
            {references.map((ref, idx) => (
              <li key={idx} className="text-sm leading-relaxed" data-testid={`reference-${idx}`}>
                <span className="text-foreground">
                  {ref.authors && <span className="text-muted-foreground">{ref.authors} </span>}
                  <span className="font-medium">{ref.title}</span>
                  {ref.source && <span className="text-muted-foreground italic"> {ref.source}</span>}
                  {ref.year && <span className="text-muted-foreground"> ({ref.year})</span>}
                </span>
                {ref.url && (
                  <a
                    href={ref.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 ml-2 text-primary hover:underline text-xs"
                    data-testid={`reference-link-${idx}`}
                  >
                    <ExternalLink className="w-3 h-3" />
                    Link
                  </a>
                )}
              </li>
            ))}
          </ol>
          <p className="text-[10px] text-muted-foreground mt-4 pt-2 border-t border-border/40">
            AI-generated references for educational context. Always verify citations against primary sources.
          </p>
        </div>
      )}
    </div>
  );
}
